import { useState, useEffect, forwardRef } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  InputGroup,
  Modal,
  Row,
  Table,
} from "react-bootstrap";
import axios from "axios";
import BASE_URL from "../../../../assets/global/url";
import {
  useNavigate,
  useParams,
  Link,
  useSearchParams,
} from "react-router-dom";
import swal from "sweetalert";
import { validateCheckNumbers } from "../../../../utils/checkNumberValidator";
import CheckNumberError from "../../../../components/inputs/CheckNumberError";
import { customStyles } from "../../../../assets/table-style";
import DataTable from "react-data-table-component";
// import { jwtDecode } from "jwt-decode";
import useDecodeToken from "../../../../hooks/customHook/useDecodeToken";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import { PaginationControls } from "../../../../hooks/customHook/paginationHook/usePagination";
import { useServerPagination } from "../../../../hooks/customHook/paginationHook/useServerPagination";
import Select from "react-select";
import { selectCustomStyles } from "../../../../assets/global/selectCustomStyles";
// import { useDateValidation } from "../../../../hooks/customHook/useDateValidation";
import {
  currencyList,
  currencySymbol,
  truncateToTwoDecimals,
  parseNumber,
} from "../../../../utils/numberFormatter";
import CustomDatePicker from "../../../../components/CustomDatePicker";
import { usePostedCutoffValidation } from "../../../../hooks/customHook/usePostedCutoffValidation";
import NumberInDecimals from "../../../../components/inputs/NumberFormatted";
import { BulkCollectionHistoryModal } from "./BulkCollectionHistoryModal";
import { warnIfNoCutoff } from "../../../../utils/cutoffDateValidation";
import TypedDateInput from "../../../../components/inputs/TypedDateInput";

const NewViewBulkCollection = ({
  authrztn,
  setId,
  setIdToAdd,
  setEdit, // To determine if user is still editing then suddenly navigates to other page
  setRoute,
}) => {
  const userLoggedID = useDecodeToken();
  // const { dateValidation } = useDateValidation();
  const { postedCutoffValidation } = usePostedCutoffValidation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [module, setModule] = useState("Local");
  const [accessType, setAccessType] = useState("");
  const [currencyName, setCurrencyName] = useState("");
  const [checkOrNone, setCheckOrNone] = useState("none");
  const { id } = useParams();
  const [isEditing, setIsEditing] = useState(false);
  const [cutOffData, setCutOffData] = useState([]);
  const [bulkCollectionData, setBulkCollectionData] = useState([]);
  const [status, setStatus] = useState("");
  const [validated, setValidated] = useState(false);
  const [subject1, setSubject1] = useState("");
  const [subject2, setSubject2] = useState("");
  const [subject3, setSubject3] = useState("");
  const [subject2DataList, setSubject2DataList] = useState([]);
  const [subject3DataList, setSubject3DataList] = useState([]);
  const [isSubject2Disabled, setIsSubject2Disabled] = useState(true);
  const [isSubject3Disabled, setIsSubject3Disabled] = useState(true);
  // const [isCustomerDisabled, setIsCustomerDisabled] = useState(true);
  // const [isTransactionDisabled, setIsTransactionDisabled] = useState(true);
  const [localCustomerData, setLocalCustomerData] = useState([]);
  const [currency_db, setCurrency_db] = useState([]);
  const [issueCheckDate, setIssueCheckDate] = useState("");
  const [processDate, setProcessDate] = useState("");
  // const [collectionDate, setCollectionDate] = useState("");
  const [isCutoffPosted, setIsCutoffPosted] = useState(false);
  const [isCutoffExists, setIsCutoffExists] = useState(true);
  const [selected_currency_id, setSelected_currency_id] = useState("");
  const [editableRow, setEditableRow] = useState(null);
  const [editedData, setEditedData] = useState({});
  const [selectedPayment, setSelectedPayment] = useState("Bank");
  const [bankAmount, setBankAmount] = useState(0);
  const [checkNumber, setCheckNumber] = useState("");
  const [refNumber, setRefNumber] = useState("");
  const [accountName, setAccountName] = useState("");
  const [amount, setAmount] = useState("");
  const [floatPayment, setFloatPayment] = useState([]);
  // const [existingTransactionIds, setExistingTransactionIds] = useState(
  //   new Set(),
  // );
  const [selectedCustomerId, setSelectedCustomerId] = useState("");
  const [transactions, setTransactions] = useState([]);
  const [totalAmountSum, setTotalAmountSum] = useState(0);
  const [items, setItems] = useState([]);
  // const [editIndex, setEditIndex] = useState(null);
  const [removeIds, setRemoveIds] = useState([]);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [selectedRow, setSelectedRow] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterColumn, setFilterColumn] = useState("all");
  // const [payAddedTransactions, setPayAddedTransactions] = useState([]);
  const [removeIdsPaymentList, setRemoveIdsPaymentList] = useState([]);
  const [selectedRowTransactions, setSelectedRowTransactions] = useState([]);
  const [transactionToGetBack, setTransactionToGetBack] = useState([]);
  const [isVisibleLiabNote, setIsVisibleLiabNote] = useState(false);
  const [currencyRate, setCurrencyRate] = useState(1);
  const [overAllDiscount, setOverallDiscount] = useState({
    type: "amount",
    value: 0,
    convertedAmount: 0,
  });
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [hasSelectedNewProcessDate, setHasSelectedNewProcessDate] =
    useState(false);

  const submitModal = () => {
    const mergedData = [
      ...new Set([...selectedRow, ...selectedRowTransactions]),
    ];

    fetchTransactions(mergedData);

    setSelectedRowTransactions(mergedData);

    setFilterColumn("all");
    setSearchTerm("");
    // setSelectedRow([]);
    pagination.setCurrentPage(1);
    handleClose();
  };

  const handleIndividualCheckBoxChange = (transaction_id) => {
    if (selectedRow.includes(transaction_id)) {
      setSelectedRow((prev) => {
        return prev.filter((item) => transaction_id !== item);
      });
    } else {
      setSelectedRow((prev) => {
        return [...prev, transaction_id];
      });
    }
  };

  const handleAllCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    if (isChecked === true) {
      setSelectedRow(transactions.map((item) => item.transaction_id));
    } else {
      setSelectedRow([]);
    }
  };
  // Access type (Management/Employee) of the logged in user, used to decide
  // whether the account balance is shown or hidden on this screen.
  const fetchAccessType = () => {
    axios
      .get(`${BASE_URL}/userRole/getUserAccessType/${userLoggedID}`)
      .then((res) => {
        setAccessType(res.data.accessType);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (userLoggedID) {
      fetchAccessType();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userLoggedID]);

  const columns = [
    {
      name: (
        <input type="checkbox" onChange={(e) => handleAllCheckboxChange(e)} />
      ),
      cell: (row) => (
        <input
          type="checkbox"
          checked={selectedRow.includes(row.transaction_id)}
          onChange={() => handleIndividualCheckBoxChange(row.transaction_id)}
        />
      ),
      width: "120px",
    },
    {
      name: "Invoice Date",
      selector: (row) =>
        row.invoice_date ? format(row.invoice_date, "MMM/dd/yyyy") : "---",
    },
    {
      name: "Due Date",
      selector: (row) =>
        row.due_date ? format(row.due_date, "MMM/dd/yyyy") : "---",
    },
    {
      name: "DR Number/ Container Number",
      selector: (row) => row.dr_number || row.container_number || "---",
      width: "18rem",
    },
    {
      name: "PO Number",
      selector: (row) => row.po_number || "---",
    },
    {
      name: "Amount",
      selector: (row) => truncateToTwoDecimals(row.total_amount) || "---",
    },
    // {
    //   name: "Discount",
    //   selector: (row) =>
    //     truncateToTwoDecimals(row.item_discount + row.transaction_discount),
    // },
  ];

  // Function to add a new row
  const addNewItem = () => {
    fetchTransactions(selectedRow);

    handleShow();
  };

  // Function to delete a row
  const deleteItem = async (item, index) => {
    setItems((prev) => {
      return prev.filter((_, i) => index !== i);
    });

    setSelectedRow((prev) => {
      return prev.filter((itemRow) => itemRow !== item.transaction_id);
    });

    setSelectedRowTransactions((prev) => {
      return prev.filter((itemRow) => itemRow !== item.transaction_id);
    });

    setRemoveIds((prev) => {
      return [...prev, item.sales_invoice_id];
    });

    if (item.payAdded === true) {
      // await axios.put(`${BASE_URL}/bulkcollection/deleteOrderListTransaction`, {
      //   id,
      //   idToRemove: item.sales_invoice_id,
      // });

      setTransactionToGetBack((prev) => [...prev, item.sales_invoice_id]);
      setIdToAdd((prev) => [...prev, item.sales_invoice_id]);
      setId(id);
      setRoute("bulkcollection");
    }
  };

  // Function to toggle edit mode
  // const toggleEdit = (index) => {
  //   setEditIndex(editIndex === index ? null : index);
  // };

  const fetchCurrency = async (currency_id) => {
    await axios
      .get(BASE_URL + "/currency/fetchCurrency")
      .then((response) => {
        setCurrency_db(response.data);
        setCurrencyName(
          response.data.find(
            (currency) => String(currency.id) === String(currency_id),
          )?.currency_name || "",
        );
      })
      .catch((error) => {
        console.error("Error fetching roles:", error);
      });
  };

  const fetchCustomer = async () => {
    await axios
      .get(BASE_URL + "/bulkcollection/getCustomerData")
      .then((response) => {
        setLocalCustomerData(response.data);
      })
      .catch((error) => {
        console.error("Error fetching roles:", error);
      });
  };

  const fetchCutOff = () => {
    axios
      .get(BASE_URL + "/bulkcollection/getCutoff")
      .then((res) => {
        setCutOffData(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSubject1Change = (event) => {
    if (checkProcessDateForPayment()) return;
    if (checkEditPayment()) return;

    const selectedSubject1 = event.target.value;
    let account_selected = "";

    if (selectedSubject1 === "Account-List") {
      setIsVisibleLiabNote(false);
      account_selected = "Account-List";
    } else if (selectedSubject1 === "Asset Account") {
      setIsVisibleLiabNote(false);
      account_selected = "Asset Account";
    } else if (selectedSubject1 === "Liabilities Account") {
      setIsVisibleLiabNote(true);
      account_selected = "Liabilities Account";
    } else if (selectedSubject1 === "Owner's Equity Account") {
      setIsVisibleLiabNote(false);
      account_selected = "Owner's Equity Account";
    }

    const clearSubjects = () => {
      setSubject1("");
      setSubject2("");
      setSubject3("");
      setBankAmount(0);
      setAccountName("");
      setAmount("");
      setIsSubject2Disabled(true);
      setIsSubject3Disabled(true);
    };

    try {
      axios
        .get(`${BASE_URL}/bulkcollection/getSubject1LocalCollection`, {
          params: {
            account_selected: account_selected,
            selectedPayment,
            selected_currency_id,
          },
        })
        .then((res) => {
          setSubject1(selectedSubject1);
          setSubject2("");
          setSubject3("");
          setAmount("");
          setBankAmount(0);
          setAccountName("");
          setIsSubject2Disabled(false);
          setIsSubject3Disabled(true);
          setSubject2DataList(res.data);
        })
        .catch((error) => {
          if (error.response && error.response.status === 404) {
            swal({
              icon: "warning",
              title: "Warning",
              text: error.response.data.message,
            }).then(() => clearSubjects());
            return;
          }
          // Handle other errors
          throw error;
        });
    } catch (error) {
      console.log(error);
      swal({
        title: "Something went wrong",
        text: "Please contact your support immediately",
        icon: "error",
      });
    }
  };

  const handleSubject2Change = (selectedOption) => {
    if (checkProcessDateForPayment()) return;
    if (checkEditPayment()) return;

    const selectedSubject2 = selectedOption;

    try {
      axios
        .get(`${BASE_URL}/bulkcollection/getSubject3LocalCollection`, {
          params: {
            subjectId: selectedSubject2?.value,
            selected_currency_id,
          },
        })
        .then((res) => {
          setSubject3DataList(res.data);
          setSubject2(selectedSubject2);
          setSubject3("");
          setBankAmount(0);
          setAccountName("");
          setIsSubject3Disabled(false); // Enable Subject 3 after Subject 2 selection
        });
    } catch (error) {
      console.log(error);
      swal({
        title: "Something went wrong",
        text: "Please contact your support immediately",
        icon: "error",
      });
    }
  };

  // Balance Details Calculations
  const activeFloatPayment = floatPayment
    .map((payment, i) =>
      editableRow === i ? { ...payment, ...editedData } : payment,
    )
    .filter(
      (payment) => payment.status !== "Rejected" && payment.isDeleted !== true,
    );

  const totalCashPaid = activeFloatPayment.reduce(
    (acc, data) =>
      data.paymentMethod === "Cash"
        ? acc + parseFloat(String(data.amount).replace(/,/g, "") || 0)
        : acc,
    0,
  );

  const totalBankPaid = activeFloatPayment.reduce(
    (acc, data) =>
      data.checkNumber === "" &&
      data.refNumber === "" &&
      data.paymentMethod === "Bank"
        ? acc + parseFloat(String(data.amount).replace(/,/g, "") || 0)
        : acc,
    0,
  );

  const totalCheckPaid = activeFloatPayment.reduce(
    (acc, data) =>
      data.checkNumber !== ""
        ? acc + parseFloat(String(data.amount).replace(/,/g, "") || 0)
        : acc,
    0,
  );

  // const totalOnlinePaid = activeFloatPayment.reduce(
  //   (acc, data) =>
  //     data.refNumber !== "" && data.paymentMethod === "Bank"
  //       ? acc + parseFloat(String(data.amount).replace(/,/g, "") || 0)
  //       : acc,
  //   0,
  // );

  const totalPayment = activeFloatPayment.reduce(
    (acc, data) => acc + parseFloat(String(data.amount).replace(/,/g, "") || 0),
    0,
  );

  const toPayAmount =
    parseFloat(totalAmountSum) - parseNumber(overAllDiscount.convertedAmount);

  // const balance_now = toPayAmount - totalPayment;

  const advance_payment =
    totalPayment - totalAmountSum <= 0 ? 0 : totalPayment - totalAmountSum;
  const balance_now = advance_payment + (toPayAmount - totalPayment);

  const handlePaymentMethod = (e) => {
    if (checkProcessDateForPayment()) return;
    if (checkEditPayment()) return;

    const paymentMethod = e.target.value;
    setSelectedPayment(paymentMethod);
    setCheckOrNone("");
    setSubject1("");
    setSubject2("");
    setSubject3("");
    setRefNumber("");
    setCheckNumber("");
    setBankAmount(0);
    setAccountName("");
    setIsSubject2Disabled(true);
    setIsSubject3Disabled(true);
  };

  const handleAccountChange = (selectedOption) => {
    if (checkProcessDateForPayment()) return;
    if (checkEditPayment()) return;

    const selectedAccountId = selectedOption?.value;
    setSubject3(selectedOption);

    // Find the selected account in the accountListData
    const selectedAccount = subject3DataList.find(
      (account) => account.id === String(selectedAccountId),
    );

    // If the account is found, update the bankAmount state with the amount
    if (selectedAccount) {
      setBankAmount(selectedAccount.amount);
      setAccountName(selectedAccount.account_name);
      setAmount(balance_now.toFixed(2).toString());
    }
  };

  const handleAmountValue = (val) => {
    if (checkProcessDateForPayment()) return;
    if (checkEditPayment()) return;

    if (val === "" || val === ".") {
      setAmount(val);
      return;
    }

    // const numericValue = parseFloat(val);
    // const accountBalance = parseFloat(bankAmount || 0);

    // if (numericValue > accountBalance && accountBalance <= balance_now) {
    //   swal({
    //     icon: "warning",
    //     title: "Amount Adjusted",
    //     text: `Please input not greater than the selected account balance. The amount adjusted to match account balance (${truncateToTwoDecimals(accountBalance)}).`,
    //     buttons: false,
    //     timer: 2000,
    //   });
    //   setAmount(accountBalance.toFixed(2).toString());
    //   return;
    // }

    // commented kasi ang lalagpas sa balance now is magiging advance payment
    // if (numericValue > balance_now) {
    //   swal({
    //     icon: "warning",
    //     title: "Amount Adjusted",
    //     text: `Please input not greater than the balance. The amount adjusted to match your remaining balance (${truncateToTwoDecimals(balance_now)}).`,
    //     buttons: false,
    //     timer: 2000,
    //   });
    //   setAmount(balance_now.toFixed(2).toString());
    //   return;
    // }

    setAmount(val);
  };

  const handleProcessDate = async (date) => {
    if (checkEditPayment()) return;

    const toDateOnly = (d) => {
      const r = new Date(d);
      r.setHours(0, 0, 0, 0);
      return r;
    };
    if (issueCheckDate && toDateOnly(date) > toDateOnly(issueCheckDate)) {
      swal({
        icon: "warning",
        title: "Invalid Process Date",
        text: "Process Date cannot be greater than the Maturity Date.",
        buttons: false,
        timer: 2500,
      });
      return;
    }

    const previousDate = processDate;

    const isPosted = await postedCutoffValidation(
      date,
      (val) => {
        setProcessDate(val === "" ? previousDate : val);
      },
      "Process Date",
    );

    if (isPosted) {
      setHasSelectedNewProcessDate(false);
      return;
    }

    setProcessDate(date);
    setHasSelectedNewProcessDate(true);
    warnIfNoCutoff(date, "Process Date");
  };

  const handleIssueCheckDate = async (date) => {
    if (checkProcessDateForPayment()) return;
    if (checkEditPayment()) return;

    const toDateOnly = (d) => {
      const r = new Date(d);
      r.setHours(0, 0, 0, 0);
      return r;
    };
    if (processDate && toDateOnly(date) < toDateOnly(processDate)) {
      swal({
        icon: "warning",
        title: "Invalid Maturity Date",
        text: "Maturity Date cannot be earlier than the Process Date.",
        buttons: false,
        timer: 2500,
      });
      return;
    }

    const previousDate = issueCheckDate;

    const isPosted = await postedCutoffValidation(
      date,
      (val) => {
        setIssueCheckDate(val === "" ? previousDate : val);
      },
      "Issue Check Date",
    );

    if (isPosted) {
      return;
    }

    setIssueCheckDate(date);
    warnIfNoCutoff(date, "Issue Check Date");
  };

  const clearPaymentFields = () => {
    setValidated(false);
    setSelectedPayment("Bank");
    setAccountName("");
    setAmount("");
    setCheckNumber("");
    setRefNumber("");
    setIssueCheckDate("");
    setSubject1("");
    setSubject2("");
    setSubject3("");
    setIsSubject2Disabled(true);
    setIsSubject3Disabled(true);
    setCheckOrNone("");
  };

  const handleAddPayment = async (e) => {
    e.preventDefault();

    if (checkProcessDateForPayment()) return;
    if (checkEditPayment()) return;

    if (!selectedPayment) {
      swal({
        icon: "error",
        title: "Payment Method Required",
        text: "Please select either Bank or Cash as the payment method.",
        buttons: false,
        timer: 2000,
      });
      return;
    }

    const formatAmount = parseFloat(amount);

    if (formatAmount <= 0) {
      swal({
        icon: "error",
        title: "Amount Required",
        text: "Please ensure the amount is greater than zero before submitting.",
        buttons: false,
        timer: 2000,
      });
      return;
    }

    const form = e.currentTarget;
    setIsVisibleLiabNote(false);

    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
      swal({
        icon: "error",
        title: "Fields are required",
        text: "Please fill the red text fields",
        buttons: false,
        timer: 2000,
      });
    } else {
      if (
        selectedPayment === "Bank" &&
        checkNumber &&
        !(await validateCheckNumbers(checkNumber, {
          pending: floatPayment
            .filter((payment) => !payment.isDeleted)
            .map((payment) => payment.checkNumber),
        }))
      )
        return;

      swal({
        title: "Add this payment?",
        text: "",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then(async (confirmed) => {
        const isForApproval = status === "For Approval";

        const newPayment = {
          paymentMethod: selectedPayment,
          subject1: subject1,
          subject2: subject2?.value,
          subject3: subject3?.value,
          accountName: accountName,
          amount: formatAmount,
          issuedDate: issueCheckDate,
          processDate: processDate,
          checkNumber: checkNumber,
          refNumber: refNumber,
          checkOrNone: checkOrNone || null,
          transactionNumber: `${bulkCollectionData.transaction_number}_p${floatPayment.length + 1}`,
          status: "Approved",
          currencyName: currencyName || null,
          currencyRate: currencyRate || null,
        };

        if (confirmed && isForApproval) {
          // setFloatPayment((prevPayments) => {
          //   // Check for matching payment based on all the conditions
          //   // const existingPaymentIndex = prevPayments.findIndex(
          //   //   (payment) =>
          //   //     payment.subject3 === newPayment.subject3 &&
          //   //     payment.issuedDate === newPayment.issuedDate &&
          //   //     // First condition: match by paymentMethod, checkNumber, and issuedDate
          //   //     ((payment.paymentMethod === newPayment.paymentMethod &&
          //   //       payment.checkNumber === newPayment.checkNumber) ||
          //   //       // Second condition: match when both are "Cash" with the same issuedDate
          //   //       (payment.paymentMethod === "Cash" &&
          //   //         newPayment.paymentMethod === "Cash") ||
          //   //       // Third condition: match when both are "Bank" with empty checkNumber, empty refNumber, and same issuedDate
          //   //       (payment.paymentMethod === "Bank" &&
          //   //         newPayment.paymentMethod === "Bank" &&
          //   //         !payment.checkNumber &&
          //   //         !payment.refNumber &&
          //   //         !newPayment.checkNumber &&
          //   //         !newPayment.refNumber) ||
          //   //       // Fourth condition: match when both are "Bank" with the same refNumber and issuedDate
          //   //       (payment.paymentMethod === "Bank" &&
          //   //         newPayment.paymentMethod === "Bank" &&
          //   //         payment.refNumber === newPayment.refNumber)),
          //   // );

          //   // if (existingPaymentIndex !== -1) {
          //   //   const updatedPayments = [...prevPayments];
          //   //   updatedPayments[existingPaymentIndex] = {
          //   //     ...updatedPayments[existingPaymentIndex],
          //   //     amount:
          //   //       updatedPayments[existingPaymentIndex].amount +
          //   //       newPayment.amount,
          //   //   };
          //   //   return updatedPayments;
          //   // }

          //   return [...prevPayments, newPayment];
          // });

          setFloatPayment((prevPayments) => {
            const payments = [...prevPayments, newPayment];

            return recalculatePayments(payments);
          });

          swal({
            icon: "success",
            title: "Payment Added",
            text: "The new payment has been added successfully",
            buttons: false,
            timer: 2000,
          }).then(() => {
            clearPaymentFields();
          });
        }

        // Handle payment for approved collections
        if (confirmed && !isForApproval) {
          const remaining_toPay = balance_now;

          const advanceAmount = Math.max(0, formatAmount - remaining_toPay);

          try {
            const res = await axios.post(
              `${BASE_URL}/bulkcollection/post-approved_payment`,
              {
                bulkCollectionId: id,
                newPayment,
                transactionNumber: bulkCollectionData.transaction_number,
                userLoggedID,
                module,
                currencyName: currencyName || null,
                currencyRate: currencyRate || null,
                advanceAmount,
              },
            );

            if (res.status === 201) {
              swal({
                icon: "success",
                title: "Payment Added",
                text: "The new payment has been added successfully",
                buttons: false,
                timer: 2000,
              }).then(() => {
                clearPaymentFields();
                setHasSelectedNewProcessDate(false);
                setProcessDate("");

                fetchLocalBulkCollection();
                setCheckOrNone("none");
              });
            }
          } catch (error) {
            console.error(error);
          }
        }
      });
    }
    setValidated(true);
  };

  // console.log(totalAmountSum, "totalamountsum");

  const handleUpdateLocalCollection = async (e) => {
    e.preventDefault();

    if (checkProcessDateForPayment()) return;
    if (checkEditPayment()) return;

    const form = e.currentTarget;

    if (!processDate) {
      swal({
        title: "Required Field Missing",
        text: "Please ensure Process Date is filled out.",
        icon: "error",
        buttons: false,
        timer: 3000,
      });
      return;
    }

    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
      swal({
        icon: "error",
        title: "Fields are required",
        text: "Please fill in the red text fields.",
      });
    } else {
      if (items.length === 0) {
        swal({
          title: "Opppss!",
          text: "Please add atleast one item to the Order List.",
          icon: "error",
          button: true,
        });
        return;
      }
      swal({
        title: "Update this collection?",
        text: "Please confirm to update this collection",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((confirmed) => {
        if (confirmed) {
          axios
            .post(`${BASE_URL}/bulkcollection/update`, {
              items,
              selectedCustomerId: selectedCustomerId?.value,
              processDate,
              floatPayment,
              userLoggedID,
              balance_now,
              id,
              removeIds: [...new Set(removeIds)],
              removeIdsPaymentList,
              totalAmount: totalAmountSum,
              currencyRate,
              discountType: overAllDiscount.type,
              discountValue: overAllDiscount.value,
              discountConvertedAmount: overAllDiscount.convertedAmount,
            })
            .then((res) => {
              if (res.status === 200) {
                swal({
                  title: "Success",
                  text: "Local collection updated successfully",
                  icon: "success",
                  buttons: false,
                  timer: 2000,
                  dangerMode: true,
                }).then(() => {
                  navigate(`/sales/view-local-bulk-collection/${id}`);
                  setValidated(false);
                  setSelectedPayment("Bank");
                  setAccountName("");
                  setAmount("");
                  setCheckNumber("");
                  setRefNumber("");
                  setIssueCheckDate("");
                  setSubject1("");
                  setSubject2("");
                  setSubject3("");
                  setIsSubject2Disabled(true);
                  setIsSubject3Disabled(true);
                  setCheckOrNone("");
                  setIsEditing(false);
                  setTransactionToGetBack([]);
                  setIdToAdd([]);
                  setId(null);
                  setEdit(false);
                  setSelectedRow([]);
                  setSelectedRowTransactions([]);
                  window.onbeforeunload = null;
                });
              } else if (res.status === 201) {
                swal({
                  title: "Opppss!",
                  text: "Cutoff already posted for this date",
                  icon: "warning",
                  buttons: false,
                  timer: 2000,
                  dangerMode: true,
                });
              } else {
                swal({
                  title: "Something Went Wrong",
                  text: "Please contact your support immediately",
                  icon: "error",
                  buttons: false,
                  timer: 2000,
                  dangerMode: true,
                });
              }
            });
        }
      });
    }
    // setValidated(true);
  };

  const handleApproveRejectLocalCollection = async (e, action) => {
    const message =
      action === "approve"
        ? "Approve this collection?"
        : "Reject this collection?";
    const status = action === "approve" ? "Approved" : "Rejected";

    // console.log(`floatPayment`, floatPayment);

    const confirmed = await swal({
      title: message,
      text: "",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (confirmed) {
      const currency = currency_db.find((c) => c.id === selected_currency_id); // For sales journal

      try {
        const transaction_num = bulkCollectionData.transaction_number;
        const res = await axios.post(
          `${BASE_URL}/bulkcollection/collections/approve-reject`,
          {
            id,
            status,
            items,
            floatPayment,
            processDate,
            userLoggedID,
            transaction_num,
            module,
            salesJournal: {
              customerId: selectedCustomerId,
              paymentType: "Credit",
              currencyId: selected_currency_id,
              currencyName: currency.currency_name,
              currencyRate: currency.currency_rate,
            },
            discountType: overAllDiscount.type,
            discountValue: overAllDiscount.value,
            discountConvertedAmount: overAllDiscount.convertedAmount,
          },
        );

        if (res.status === 200) {
          swal({
            title: "Success",
            text:
              action === "approve"
                ? "Local collection has been approved"
                : "Local collection has been rejected",
            icon: "success",
            buttons: false,
            timer: 2000,
            dangerMode: true,
          }).then(() => {
            navigate(
              `/sales/local-collections?page=${searchParams.get("page")}`,
            );
          });
        } else if (res.status === 202) {
          const { invoiceDate, CutoffName, status } = res.data;
          let invoiceStatus;
          if (status === "Approved") {
            invoiceStatus = "Approval";
          } else {
            invoiceStatus = "Rejection";
          }
          swal({
            title: `${invoiceStatus} Declined`,
            text: `Transaction cannot be ${status} as its collection date (${invoiceDate}) falls within the posted cutoff period named "${CutoffName}".`,
            icon: "warning",
            button: "OK",
          });
        }
      } catch (error) {
        if (error.response && error.response.status === 400) {
          swal({
            title: "Failed to Update Collection",
            text:
              error.response.data.message ||
              "Failed to update local collection.",
            icon: "error",
            buttons: false,
            timer: 2000,
            dangerMode: true,
          });
        } else if (error.response.status === 401) {
          swal({
            icon: "error",
            // title: "Please contact your support",
            title: error.response.data.title,
            text: error.response.data.message,
          }); // test 1
        } else {
          console.error("Error saving payment:", error);
          swal({
            title: "Something went wrong",
            text: "Please contact your support immediately",
            icon: "error",
            buttons: false,
            timer: 2000,
            dangerMode: true,
          });
        }
      }
    }
    setValidated(true);
  };

  const fetchLocalBulkCollection = () => {
    axios
      .get(`${BASE_URL}/bulkcollection/viewLocalBulkCollection`, {
        params: { id: id },
      })
      .then((res) => {
        if (res.data) {
          const { data, isPosted, cutoffExists } = res.data;
          setBulkCollectionData(data);
          setSelectedCustomerId(data.customer_id);
          setSelected_currency_id(data.currency_id);
          setProcessDate(data.collection_date);
          setCurrencyRate(data.rate);
          fetchCurrency(data.currency_id);
          setIsCutoffPosted(isPosted);
          setIsCutoffExists(cutoffExists);
          setStatus(data.status);
          setModule(data.type);
          setOverallDiscount({
            type: data?.ovad_t,
            value: data?.ovad_value,
            convertedAmount: data?.ovad_converted,
          });
          if (
            data.bulk_collection_transactions &&
            data.bulk_collection_transactions.length > 0
          ) {
            // const existingIds = new Set(
            //   data.bulk_collection_transactions.map((transaction) =>
            //     transaction.sales_invoice.sales_invoice_id.toString(),
            //   ),
            // );
            // setExistingTransactionIds(existingIds);
            // console.log(data.bulk_collection_transactions);

            const mappedItems = data.bulk_collection_transactions.map(
              (transaction) => ({
                sales_invoice_id: transaction.sales_invoice_id,
                transaction_id: transaction.sales_invoice.transaction_id,
                client_transaction_id:
                  transaction.sales_invoice.client_transaction_id,
                remarks: transaction.sales_invoice.remarks,
                invoice_date: transaction.sales_invoice.invoice_date,
                due_date: transaction.sales_invoice.due_date,
                total_amount: transaction.sales_invoice.total_amount,
                transaction_discount:
                  parseFloat(transaction.sales_invoice.transaction_discount) ||
                  0,
                item_discount:
                  parseFloat(transaction.sales_invoice.item_discount) || 0,
                discount_type: transaction.sales_invoice.discount_type,
                payAdded: transaction.sales_invoice.payAdded,
                collectionDiscountType:
                  transaction.collection_discount_type || "percent",
                collectionDiscountValue:
                  transaction.collection_discount_value || "",
                collectionDiscountOperator:
                  transaction.collection_discount_operator || "+",
                collectionDiscountConverted:
                  transaction.collection_discount_converted || 0,
              }),
            );
            setItems(mappedItems);
          }

          const formattedPayments = data.bulk_collection_payments.map(
            (payment) => ({
              id: payment.id,
              transactionNumber: payment.transaction_number,
              paymentMethod: payment.payment_type,
              accountName: payment.account_list_sub3
                ? payment.account_list_sub3.account_name
                : "",
              amount: payment.amount,
              checkNumber: payment.check_number || "",
              refNumber: payment.ref_number || "",
              issuedDate: payment.date_issued,
              processDate: payment.process_date,
              subject3: payment.account_list_sub3_id,
              checkOrNone: payment.checkOrNone || null,
              status: payment.status,
              isDeleted: payment.isDeleted,
              advancePayment_tb:
                payment.bulk_collection_advance_payments.length > 0
                  ? payment.bulk_collection_advance_payments[0]
                  : null,
              isAdvancePayment:
                payment.bulk_collection_advance_payments.length > 0,
              advanceAmount:
                payment.bulk_collection_advance_payments.length > 0
                  ? payment.bulk_collection_advance_payments[0].amount
                  : 0,
            }),
          );

          setFloatPayment(formattedPayments);
        }
      })
      .catch((err) => console.log(err));
  };

  // console.log(`FloatPayment`, floatPayment);
  const pagination = useServerPagination(
    `${BASE_URL}/bulkcollection/getTransactionsByCustomerLocal`,
    10,
  );

  // const paginationHook = usePagination(transactions, 10);

  const fetchTransactions = async (selectedRowTransactions) => {
    pagination.updateParams({
      customer_id: bulkCollectionData.customer_id,
      selected_currency_id,
      searchText: searchTerm,
      filterColumn,
      selectedRow: selectedRowTransactions,
    });
  };

  // console.log(items, "items");

  // const getAvailableTransactionIds = (index) => {
  //   const selectedTransactionIds = items
  //     .map((item, idx) => (idx !== index ? item.transactionId : null))
  //     .filter((id) => id);

  //   if (index === 0) {
  //     return transactions.filter(
  //       (transaction) =>
  //         !selectedTransactionIds.includes(
  //           transaction.sales_invoice_id.toString(),
  //         ) ||
  //         items[index].transactionId ===
  //           transaction.sales_invoice_id.toString(),
  //     );
  //   }

  //   const firstRowTransactionId = items[0].transactionId;
  //   return transactions.filter((transaction) => {
  //     const transactionIdStr = transaction.sales_invoice_id.toString();
  //     return (
  //       (!selectedTransactionIds.includes(transactionIdStr) &&
  //         transactionIdStr !== firstRowTransactionId &&
  //         transaction.payAdded === false) ||
  //       items[index].transactionId === transactionIdStr
  //     );
  //   });
  // };

  // const handleTransactionChange = (index, transactionId) => {
  //   const transaction = transactions.find(
  //     (t) => t.sales_invoice_id === String(transactionId),
  //   );
  //   console.log(transaction);
  //   if (transaction) {
  //     const updatedItems = [...items];
  //     updatedItems[index] = {
  //       ...updatedItems[index],
  //       transactionId: transactionId,
  //       remarks: transaction.remarks,
  //       invoiceDate: transaction.createdAt
  //         ? new Date(transaction.createdAt).toISOString().split("T")[0]
  //         : "",
  //       dueDate: transaction.due_date
  //         ? new Date(transaction.due_date).toISOString().split("T")[0]
  //         : "",
  //       totalAmount: transaction.total_amount || 0,
  //       discount:
  //         (transaction.transaction_discount || 0) +
  //         (transaction.item_discount || 0),
  //       discountType: transaction.discount_type || "",
  //     };
  //     setItems(updatedItems);
  //   }
  // };

  // const handleDeletePayment = (index, data) => {
  //   setFloatPayment((prevPayments) => {
  //     const filteredPayments = prevPayments.filter((_, i) => i !== index);

  //     const updatedPayments = filteredPayments.map((payment, newIndex) => {
  //       const baseTn = payment.transactionNumber
  //         ? payment.transactionNumber.split("_p")[0]
  //         : bulkCollectionData.transaction_number;

  //       return {
  //         ...payment,
  //         transactionNumber: `${baseTn}_p${newIndex + 1}`,
  //       };
  //     });

  //     return updatedPayments;
  //   });

  //   if (data.id) {
  //     setRemoveIdsPaymentList((prev) => [...prev, data.id]);
  //   }
  // };

  const handleDeletePayment = (index, data) => {
    setFloatPayment((prevPayments) => {
      const filtered = prevPayments.filter((_, i) => i !== index);

      const renamed = filtered.map((payment, newIndex) => {
        const baseTn = payment.transactionNumber.split("_p")[0];

        return {
          ...payment,
          transactionNumber: `${baseTn}_p${newIndex + 1}`,
        };
      });

      return recalculatePayments(renamed);
    });

    if (data.id) {
      setRemoveIdsPaymentList((prev) => [...prev, data.id]);
    }
  };

  const isTableDisabled = status === "Approved" || status === "Rejected";

  const isPaymentInputDisabled =
    status === "Rejected" ||
    balance_now <= 0 ||
    (status === "For Approval" && !isEditing);

  // Subject 2 Options for dropdown select
  const subject2Options = subject2DataList.map((item) => ({
    value: item.id,
    label: item.subject_name,
    subject_type: item.subject_type,
  }));

  // Subject 3 Options for dropdown select
  const subject3Options = subject3DataList.map((item) => ({
    value: item.id,
    label: item.account_name,
  }));

  // Custom input for DatePicker. The calendar works as before; the date can
  // also be typed (TypedDateInput: MM/dd/yyyy, shown as Oct/10/2026). A typed
  // date goes through the DatePicker onChange, same as a calendar pick.
  const CustomInput = forwardRef(
    (
      {
        label,
        value,
        onClick,
        onChange,
        onFocus,
        onBlur,
        onKeyDown,
        generateYears,
        index,
        disabled,
      },
      ref,
    ) => {
      let dynamicPlaceholder = "Select Date";
      let displayValue = value;
      let cursorStyle = disabled ? "not-allowed" : "pointer";
      let isReadView = false;

      if (label === "Process Date") {
        const isReadStatus =
          status === "Claimed" ||
          (balance_now === 0 && status !== "For Approval");

        const isApprovedStatus = ["Approved", "Partially Collected"].includes(
          status,
        );

        if (isReadStatus) {
          isReadView = true;
          displayValue = "";
          dynamicPlaceholder = "Click the icon to view payment history";
          cursorStyle = "default";
        } else if (isApprovedStatus) {
          if (!hasSelectedNewProcessDate) {
            displayValue = "";
            dynamicPlaceholder = "Click to Select Process Date";
          }
        }
      }

      const isDisabled =
        disabled || // Apply the disabled prop from parent
        (index !== undefined
          ? editableRow !== index
          : (label === "Process Date" || label === "Issue Check Date") &&
              status === "For Approval"
            ? !isEditing
            : isPaymentInputDisabled);

      const inputStyle = {
        cursor: cursorStyle,
        padding: `${index !== undefined ? "0.4rem" : "0.5rem"}`,
      };

      const handleClick = (e) => {
        if (isDisabled) return; // Prevent clicking when disabled
        onClick(e);

        const date = new Date(value).getFullYear();

        if (generateYears) generateYears(date); // Reset/Initialize Year List based on selected date of birth
      };

      // Payment history view: nothing to type
      if (isReadView) {
        return (
          <input
            type="text"
            className="form-control w-100"
            style={{ ...inputStyle, caretColor: "transparent" }}
            onClick={handleClick}
            onKeyDown={onKeyDown}
            value={displayValue}
            ref={ref}
            placeholder={dynamicPlaceholder}
            readOnly
            required
            disabled={isDisabled}
          />
        );
      }

      return (
        <TypedDateInput
          className="form-control w-100"
          style={inputStyle}
          onClick={handleClick}
          // Clearing the text doesn't clear the date: it snaps back on blur
          onChange={(e) => e.target.value && onChange(e)}
          onFocus={onFocus}
          onBlur={onBlur}
          onKeyDown={onKeyDown}
          value={displayValue}
          ref={ref}
          placeholder={dynamicPlaceholder}
          required
          disabled={isDisabled}
        />
      );
    },
  );

  if (isEditing === true) {
    window.onbeforeunload = (e) => {
      e.preventDefault();
      const payload = JSON.stringify({ id, idToAdd: transactionToGetBack });
      const blob = new Blob([payload], { type: "application/json" });

      navigator.sendBeacon(
        `${BASE_URL}/bulkcollection/getBackOrderListTransaction`,
        blob,
      );

      setIsEditing(false);
      window.onbeforeunload = null; // To clean up the event listener
      return "";
    };
  }

  useEffect(() => {
    if (selectedPayment === "Cash") {
      if (processDate) {
        // If a process date is selected, copy it to the maturity date
        setIssueCheckDate(processDate);
      } else {
        // Fallback to today if no process date is selected yet
        const today = new Date();
        const month = String(today.getMonth() + 1).padStart(2, "0");
        const day = String(today.getDate()).padStart(2, "0");
        const year = today.getFullYear();
        const currentDate = `${year}-${month}-${day}`;

        setIssueCheckDate(currentDate);
        setProcessDate(currentDate);
      }
      setHasSelectedNewProcessDate(true);
    }
  }, [selectedPayment, processDate]);

  // useEffect(() => {
  //   const sum = items.reduce(
  //     (acc, item) => acc + parseFloat(item.total_amount || 0),
  //     0,
  //   );
  //   setTotalAmountSum(sum);
  // }, [items]);

  useEffect(() => {
    let grossAmount = 0;
    let totalDiscount = 0;

    items.forEach((item) => {
      const amount = parseFloat(item.total_amount) || 0;
      grossAmount += amount;

      let itemDiscount = 0;
      const discVal = parseFloat(item.collectionDiscountValue) || 0;

      if (item.collectionDiscountType === "percent") {
        itemDiscount = (discVal / 100) * amount;
      } else {
        itemDiscount = discVal;
      }

      // Plus adds to overall discount, minus deducts
      if (item.collectionDiscountOperator === "-") {
        totalDiscount -= itemDiscount;
      } else {
        totalDiscount += itemDiscount;
      }
    });

    setTotalAmountSum(grossAmount);
    setOverallDiscount({
      type: "amount",
      value: totalDiscount,
      convertedAmount: totalDiscount,
    });
  }, [items]);

  useEffect(() => {
    fetchLocalBulkCollection();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, isEditing]);

  useEffect(() => {
    fetchTransactions(selectedRowTransactions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bulkCollectionData.customer_id]);

  useEffect(() => {
    fetchCustomer();
    fetchCutOff();
  }, []);

  useEffect(() => {
    fetchTransactions(selectedRowTransactions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm]);

  useEffect(() => {
    setSearchTerm("");
  }, [filterColumn]);

  useEffect(() => {
    setTransactions(pagination.data.data);

    if (pagination?.data?.items) {
      // Skip if all selectedRows already exist in items
      const existingIds = items.map((item) => item.transaction_id);
      const isFullySynced =
        selectedRow.every((id) => existingIds.includes(id)) &&
        items.length === selectedRow.length;

      if (isFullySynced) return;

      const newItems = pagination.data.items.filter(
        (item) =>
          selectedRow.includes(item.transaction_id) &&
          !existingIds.includes(item.transaction_id),
      );

      if (newItems.length > 0) {
        setItems((prev) => [
          ...prev,
          ...newItems.map((item) => ({
            ...item,
            collectionDiscountType: "percent",
            collectionDiscountValue: "",
            collectionDiscountOperator: "+",
            collectionDiscountConverted: 0,
          })),
        ]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.data.data]);

  // function to handle currency rate formatting (similar to create_invoice.jsx)
  const handleCurrencyRateChange = (e) => {
    let inputValue = e.target.value.replace(/[^0-9.]/g, "");
    if ((inputValue.match(/\./g) || []).length > 1) return;
    let [integerPart, decimalPart] = inputValue.split(".");
    if (integerPart) {
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    let formattedValue =
      decimalPart !== undefined ? `${integerPart}.${decimalPart}` : integerPart;

    setCurrencyRate(formattedValue);
  };

  const handleItemDiscountChange = (index, key, value) => {
    setItems((prev) => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        [key]: value,
      };
      return updated;
    });
  };

  const handleCancelEdit = () => {
    if (checkProcessDateForPayment()) return;
    if (checkEditPayment()) return;
    swal({
      title: "Cancel Changes?",
      text: "Any unsaved changes will be lost. Do you want to proceed?",
      icon: "warning",
      buttons: ["No", "Yes"],
      dangerMode: true,
    }).then(async (confirmed) => {
      if (confirmed) {
        try {
          if (transactionToGetBack.length > 0) {
            await axios.post(
              `${BASE_URL}/bulkcollection/getBackOrderListTransaction`,
              { id, idToAdd: transactionToGetBack },
            );
          }

          setIsEditing(false);
          setTransactionToGetBack([]);
          setRemoveIds([]);
          setRemoveIdsPaymentList([]);
          setSelectedRow([]);
          setSelectedRowTransactions([]);
          window.onbeforeunload = null;

          fetchLocalBulkCollection();
        } catch (error) {
          console.error("Error cancelling edit:", error);
          swal(
            "Error",
            "Failed to revert changes properly. Please refresh the page.",
            "error",
          );
        }
      }
    });
  };

  const checkEditPayment = () => {
    if (editableRow !== null) {
      swal({
        icon: "warning",
        title: "Payment Edit in Progress",
        text: "Please click (✔) or (✖) buttons of your current payment edit before performing other actions.",
      });
      return true;
    }
    return false;
  };

  const handleEditClick = (index, data) => {
    if (checkEditPayment()) return;
    setEditableRow(index);
    setEditedData({ ...data });
  };

  const handleEditAmountValue = (val) => {
    if (val === "" || val === ".") {
      setEditedData((prev) => ({ ...prev, amount: val }));
      return;
    }

    // const numericValue = parseFloat(val);

    // const sumOfOtherPayments = floatPayment.reduce((acc, data, i) => {
    //   if (i === editableRow) return acc;
    //   return acc + parseFloat(String(data.amount).replace(/,/g, "") || 0);
    // }, 0);

    // const maxAllowed = toPayAmount - sumOfOtherPayments;

    // if (numericValue > maxAllowed) {
    //   swal({
    //     icon: "warning",
    //     title: "Amount Adjusted",
    //     text: `Please input not greater than the balance. The amount adjusted to match your remaining balance (${truncateToTwoDecimals(maxAllowed)}).`,
    //     buttons: false,
    //     timer: 2000,
    //   });
    //   setEditedData((prev) => ({
    //     ...prev,
    //     amount: maxAllowed.toFixed(2).toString(),
    //   }));
    //   return;
    // }

    setEditedData((prev) => ({ ...prev, amount: val }));
  };

  // commented kasi meron na updated version para sa advance payment
  // const handleSaveEdit = (index) => {
  //   if (editableRow === index) {
  //     setFloatPayment((prevPayments) => {
  //       const updatedPayments = prevPayments.map((payment, i) =>
  //         i === index ? { ...payment, ...editedData } : payment,
  //       );

  //       return updatedPayments;
  //     });
  //     setEditableRow(null);
  //   }
  // };

  const recalculatePayments = (payments) => {
    let remainingReceivable = toPayAmount;

    return payments.map((payment) => {
      const paymentAmount = Number(payment.amount);

      const appliedAmount = Math.min(paymentAmount, remainingReceivable);

      const advanceAmount = Math.max(0, paymentAmount - remainingReceivable);

      remainingReceivable = Math.max(0, remainingReceivable - appliedAmount);

      return {
        ...payment,
        appliedAmount,
        advanceAmount,
        isAdvancePayment: advanceAmount > 0,
      };
    });
  };

  const handleSaveEdit = async (index) => {
    if (editableRow !== index) return;
    const originalCheck = floatPayment[index]?.checkNumber || "";
    if (
      editedData.checkNumber &&
      editedData.checkNumber.trim() !== originalCheck.trim() &&
      !(await validateCheckNumbers(editedData.checkNumber, {
        pending: floatPayment
          .filter((payment, i) => i !== index && !payment.isDeleted)
          .map((payment) => payment.checkNumber),
      }))
    )
      return;

    setFloatPayment((prev) => {
      const updated = prev.map((payment, i) =>
        i === index ? { ...payment, ...editedData } : payment,
      );

      return recalculatePayments(updated);
    });
    setEditableRow(null);
  };

  const handleEditIssuedDate = async (date, index) => {
    if (editableRow !== index) return;

    const previousDate = editedData.issuedDate;

    const safeSetter = (val) => {
      setEditedData((prev) => ({
        ...prev,
        issuedDate: val === "" ? previousDate : val,
      }));
    };

    const isPosted = await postedCutoffValidation(
      date,
      safeSetter,
      "Issued Check Date",
    );

    if (isPosted) return;

    setEditedData((prev) => ({
      ...prev,
      issuedDate: date,
    }));
  };

  const checkProcessDateForPayment = () => {
    if (status !== "For Approval") {
      if (!hasSelectedNewProcessDate || !processDate) {
        swal({
          icon: "warning",
          title: "Process Date Required",
          text: "Please select a process date first before selecting payment details.",
          buttons: false,
          timer: 2500,
        });
        return true;
      }
    } else {
      if (!processDate) {
        swal({
          icon: "warning",
          title: "Process Date Required",
          text: "Please ensure the Process Date is filled out before adding a payment.",
          buttons: false,
          timer: 2500,
        });
        return true;
      }
    }
    return false;
  };

  return (
    <div className="h-100 w-100 bg-white custom-container">
      <div className="w-100 d-flex flex-row justify-content-between">
        <div className="d-flex flex-column title-custom">
          <span className="fs-3">
            {" "}
            <Link
              to="/sales/local-collections"
              state={{ fromViewPage: true }}
              className="text-dark mx-2"
            >
              <i class="fa-solid fa-arrow-left"></i>
            </Link>
            COLLECTIONS OVERVIEW
          </span>
          <p className="fs-6">
            Status:{" "}
            <span
              style={{
                color:
                  status === "For Approval"
                    ? "orange"
                    : status === "Approved"
                      ? "green"
                      : "red",
                textTransform: "uppercase",
              }}
            >
              {status}
            </span>
          </p>
        </div>
      </div>

      <Container fluid className="mt-3">
        <Row className="p-2">
          <Col sm>
            <span>Transaction Number</span>
            <Form.Control
              type="text"
              name="transactionNumber"
              id="transactionNumber"
              value={bulkCollectionData.transaction_number}
              className="p-2 pointer-events-none"
              readOnly
            />
          </Col>
          <Col sm>
            <span>Process Date</span>
            <InputGroup>
              {status !== "For Approval" && (
                <InputGroup.Text
                  className="cursor-pointer"
                  onClick={() => setShowHistoryModal(true)}
                  title="View Collection History"
                >
                  <i className="fas fa-history"></i>
                </InputGroup.Text>
              )}
              <CustomDatePicker
                label={"Process Date"}
                selected={processDate ? new Date(processDate) : ""}
                handleDateChange={handleProcessDate}
                CustomInput={CustomInput}
                isRequired={true}
                validated={validated}
                //disabled={selectedPayment === "Cash"} // Add this line
                maxDate={
                  issueCheckDate
                    ? new Date(
                        new Date(issueCheckDate).setHours(23, 59, 59, 999),
                      )
                    : undefined
                }
              />
            </InputGroup>
            <BulkCollectionHistoryModal
              show={showHistoryModal}
              onHide={() => setShowHistoryModal(false)}
              bulkCollectionId={id}
            />
          </Col>
        </Row>
        <Row className="row p-2">
          <Col sm>
            <span>Currency</span>
            {/* {selected_currency_id &&
            selected_currency_id !== "11111111-1111-1111-1111-111111111111" ? (
              <span className="text-muted mb-1">
                {" | "}
                Current Rate: {currencyRate}
              </span>
            ) : null} */}
            <InputGroup className="mb-2">
              <Form.Select
                className="p-2"
                required
                disabled
                value={selected_currency_id}
              >
                <option value="" selected disabled>
                  Select Currency
                </option>
                {currency_db.map((data) => (
                  <option key={data.id} value={data.id}>
                    {data.currency_name} - {currencyList[data.currency_name]}
                  </option>
                ))}
              </Form.Select>
            </InputGroup>
          </Col>
          {selected_currency_id &&
          selected_currency_id !== "11111111-1111-1111-1111-111111111111" ? (
            <Col sm className="d-none">
              <span>Currency Rate</span>
              <Form.Control
                type="text"
                name="currencyRate"
                id="currencyRate"
                className="p-2"
                required
                onChange={handleCurrencyRateChange}
                value={currencyRate}
                disabled={!isEditing}
              />
            </Col>
          ) : null}
          <Col sm>
            <span>Customer</span>
            <InputGroup className="mb-2">
              <Form.Select
                className="p-2"
                required
                value={selectedCustomerId}
                disabled
              >
                <option value="" selected disabled>
                  Select Customer
                </option>
                {localCustomerData.map((customer, i) => (
                  <option key={i} value={customer.customer_id}>
                    {/* Company name first, else first name + last name (last name only if available) */}
                    {customer.company_name ||
                      [customer.first_name, customer.last_name]
                        .filter(Boolean)
                        .join(" ")}
                  </option>
                ))}
              </Form.Select>
            </InputGroup>
          </Col>
        </Row>
        <Row className="p-2">
          <Col sm>
            <span>Receivable Balance</span>
            <InputGroup className="mb-2">
              <InputGroup.Text>
                {currencySymbol[currencyName] || ""}
              </InputGroup.Text>
              <Form.Control
                type="text"
                className="p-2 pointer-events-none"
                id="totalAmountSum"
                value={truncateToTwoDecimals(totalAmountSum)}
                readOnly
              />
            </InputGroup>
          </Col>
          <Col sm>
            <div className="p-0">
              <span>Closed Discount</span>
              <InputGroup className="mb-2">
                <InputGroup.Text>
                  {currencySymbol[currencyName] || ""}
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  className="p-2 pointer-events-none"
                  id="overallDiscountAmount"
                  value={truncateToTwoDecimals(overAllDiscount.convertedAmount)}
                  readOnly
                />
              </InputGroup>
            </div>
          </Col>
        </Row>
      </Container>
      <Container fluid>
        <div className="w-100 d-flex align-items-center mt-3 p-2">
          <h5>Order List</h5>
          <hr className="flex-grow-1 mx-3" />
        </div>
        <div className="w-100 mt-2 p-2 new-item-custom scrollable-contents">
          <Table bordered hover responsive className="fixed-inputs-table">
            <thead className="table-light">
              <tr>
                <th className="p-2">Transaction ID</th>
                <th className="p-2">Remarks</th>
                <th className="p-2">Invoice Date</th>
                <th className="p-2">Due Date</th>
                <th className="p-2">Amount</th>
                <th className="p-2">Collection Discount</th>
                {isEditing && <th className="p-2">Action</th>}
              </tr>
            </thead>
            {items.length > 0 ? (
              <tbody>
                {items.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <Form.Control
                        type="text"
                        className="d-none"
                        readOnly
                        value={item.transaction_id || "---"}
                      />
                      <Form.Control
                        type="text"
                        className="pointer-events-none"
                        readOnly
                        value={item.client_transaction_id || "---"}
                      />
                    </td>
                    <td>
                      <Form.Control
                        type="text"
                        className="pointer-events-none"
                        readOnly
                        value={item.remarks || "---"}
                      />
                    </td>
                    <td>
                      <DatePicker
                        selected={item.invoice_date}
                        dateFormat="MMM/dd/yyyy"
                        className="form-control p-2 pointer-events-none"
                        readOnly
                      />
                    </td>
                    <td>
                      <DatePicker
                        selected={item.due_date}
                        dateFormat="MMM/dd/yyyy"
                        className="form-control p-2 pointer-events-none"
                        readOnly
                      />
                    </td>
                    <td>
                      <InputGroup>
                        <InputGroup.Text>
                          {currencySymbol[currencyName] || ""}
                        </InputGroup.Text>
                        <Form.Control
                          type="text"
                          className="pointer-events-none"
                          value={truncateToTwoDecimals(item.total_amount)}
                          readOnly
                        />
                      </InputGroup>
                    </td>
                    <td>
                      <InputGroup>
                        <InputGroup.Text
                          id={`discount-type-${index}`}
                          style={{
                            cursor: isEditing ? "pointer" : "default",
                            userSelect: "none",
                          }}
                          onClick={() => {
                            if (!selectedCustomerId || !isEditing) return;
                            const newType =
                              item.collectionDiscountType === "percent"
                                ? "amount"
                                : "percent";
                            let newValue = item.collectionDiscountValue;

                            if (
                              newType === "percent" &&
                              parseFloat(newValue) >= 100
                            ) {
                              newValue = 100;
                            }

                            setItems((prev) => {
                              const updated = [...prev];
                              updated[index] = {
                                ...updated[index],
                                collectionDiscountType: newType,
                                collectionDiscountValue: newValue,
                              };
                              return updated;
                            });
                          }}
                        >
                          {item.collectionDiscountType === "percent"
                            ? "%"
                            : currencySymbol[currencyName] || ""}
                        </InputGroup.Text>
                        <NumberInDecimals
                          className="form-control"
                          disabled={!selectedCustomerId || !isEditing}
                          value={item.collectionDiscountValue || ""}
                          placeholder="0.00"
                          decimals={2}
                          max={
                            item.collectionDiscountType === "percent"
                              ? 100
                              : parseFloat(item.total_amount)
                          }
                          onChange={(val) =>
                            handleItemDiscountChange(
                              index,
                              "collectionDiscountValue",
                              val,
                            )
                          }
                        />
                        <InputGroup.Text
                          id={`discount-operator-${index}`}
                          style={{
                            cursor: isEditing ? "pointer" : "default",
                            userSelect: "none",
                          }}
                          onClick={() => {
                            if (!selectedCustomerId || !isEditing) return;
                            const newOp =
                              item.collectionDiscountOperator === "+"
                                ? "-"
                                : "+";
                            handleItemDiscountChange(
                              index,
                              "collectionDiscountOperator",
                              newOp,
                            );
                          }}
                        >
                          {item.collectionDiscountOperator || "+"}
                        </InputGroup.Text>
                      </InputGroup>
                    </td>
                    {isEditing && (
                      <td className="text-center">
                        <Button
                          size="sm"
                          variant="outline-danger"
                          disabled={
                            status !== "For Approval" ||
                            !isEditing ||
                            (items.length === 1 && index === 0)
                          }
                          onClick={() => deleteItem(item, index)}
                        >
                          <i className="fa-solid fa-trash-can"></i>
                        </Button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            ) : (
              <caption className="text-center mt-3">
                There are no records to display
              </caption>
            )}
          </Table>
        </div>
        {status === "For Approval" && (
          <>
            <div className="w-100 d-flex justify-content-end mt-2">
              <Button
                size="sm"
                variant="primary"
                type="button"
                onClick={addNewItem}
                disabled={isTableDisabled || !isEditing}
              >
                New Item
              </Button>
            </div>
            <Modal
              show={show}
              size="xl"
              onHide={() => {
                setFilterColumn("all");
                setSearchTerm("");
                handleClose();
              }}
            >
              <Modal.Header closeButton>
                <Modal.Title>Order List</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Row className="mb-3">
                  <InputGroup>
                    <Form.Control
                      type="text"
                      placeholder="Search"
                      value={searchTerm}
                      onChange={(e) => {
                        let input = e.target.value;

                        // Remove commas
                        const raw = String(input).replace(/,/g, "");

                        const [intPart, decimalPart] = raw.split(".");

                        // Add commas to integer part
                        const withCommas = intPart.replace(
                          /\B(?=(\d{3})+(?!\d))/g,
                          ",",
                        );

                        // Join back decimal part if it exists
                        const formatted =
                          decimalPart !== undefined
                            ? `${withCommas}.${decimalPart}`
                            : withCommas;

                        if (
                          transactions.find((item) => {
                            const price = item.total_amount;
                            const precision17 = Number(
                              price.toPrecision(17),
                            ).toString();
                            const fixed17 = price.toFixed(17);
                            const fixed2 = price.toFixed(2);

                            return (
                              precision17.includes(raw) ||
                              fixed17.includes(raw) ||
                              fixed2.includes(raw)
                            );
                          })
                        ) {
                          setSearchTerm(formatted);
                        } else {
                          setSearchTerm(e.target.value);
                        }
                      }}
                    />
                    <Button
                      variant="outline-secondary"
                      type="button"
                      className="dropdown-toggle-split"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i className="fa-solid fa-sliders"></i>
                    </Button>
                    <ul className="dropdown-menu dropdown-menu-end">
                      <li>
                        <button
                          className={`dropdown-item ${
                            filterColumn === "all" ? "active" : ""
                          }`}
                          onClick={() => setFilterColumn("all")}
                        >
                          All
                        </button>
                      </li>
                      {[
                        // { value: "transaction_id", label: "Transaction ID" },
                        // { value: "remarks", label: "Remarks" },
                        { value: "invoice_date", label: "Invoice Date" },
                        { value: "due_date", label: "Due Date" },
                        {
                          value: "dr_number",
                          label: "DR Number / Container Number",
                        },
                        {
                          value: "po_number",
                          label: "PO Number",
                        },
                        { value: "total_amount", label: "Amount" },
                        // { value: "discount", label: "Discount" },
                      ].map(({ value, label }) => (
                        <li key={value}>
                          <button
                            className={`dropdown-item ${
                              filterColumn === value ? "active" : ""
                            }`}
                            onClick={() => setFilterColumn(value)}
                          >
                            {label}
                          </button>
                        </li>
                      ))}
                    </ul>
                  </InputGroup>
                </Row>
                <DataTable
                  columns={columns}
                  data={transactions}
                  customStyles={customStyles}
                  onRowClicked={(row) =>
                    handleIndividualCheckBoxChange(row.transaction_id)
                  }
                  className="dataTable"
                />
                <PaginationControls {...pagination} />
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => {
                    setFilterColumn("all");
                    setSearchTerm("");
                    handleClose();
                  }}
                >
                  Close
                </Button>
                <Button variant="primary" onClick={submitModal}>
                  Submit
                </Button>
              </Modal.Footer>
            </Modal>
          </>
        )}
      </Container>

      <Container fluid>
        <div className="w-100 d-flex align-items-center mt-3 p-2">
          <h5>Payment</h5>
          <hr className="flex-grow-1 mx-3" />
        </div>
        <Row className="w-100 p-2 mt-1">
          <Col xs={12} md={4} className="p-2">
            <div className="w-100 border shadow-sm p-3 rounded">
              <div className="w-100 d-flex flex-column payment-card border-bottom pb-2 mb-3">
                <span className="fw-bold">Payment Method</span>
                {(status === "Approved" || status === "Partially Collected") &&
                  !hasSelectedNewProcessDate && (
                    <span className="text-danger small mt-1">
                      Please select a process date first at the top *
                    </span>
                  )}
              </div>
              <Form validated={validated} onSubmit={handleAddPayment}>
                <Form.Group className="mb-3" controlId="payWith">
                  <Form.Label className="fw-bold">Pay With:</Form.Label>
                  <div className="d-flex">
                    <Form.Check
                      type="radio"
                      name="paymentType"
                      id="bank"
                      label="Bank"
                      value="Bank"
                      checked={selectedPayment === "Bank"}
                      onChange={handlePaymentMethod}
                      className="me-3"
                      disabled={isPaymentInputDisabled}
                    />
                    <Form.Check
                      type="radio"
                      name="paymentType"
                      id="cash"
                      label="Cash"
                      value="Cash"
                      checked={selectedPayment === "Cash"}
                      onChange={handlePaymentMethod}
                      className="me-3"
                      disabled={isPaymentInputDisabled}
                    />
                  </div>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">
                    Check Status{" "}
                    <span className="text-muted badge fst-italic fw-lighter">
                      (Check / Non-Cheque)
                    </span>
                  </Form.Label>
                  <Form.Select
                    onChange={(e) => {
                      if (checkProcessDateForPayment()) return;
                      if (checkEditPayment()) return;
                      const checkStatusValue = e.target.value;
                      setCheckOrNone(checkStatusValue);
                      // Reset the Step 1-3 account selection and its balance
                      // display whenever Check Status changes, in either
                      // direction (same reset handlePaymentMethod already does).
                      setSubject1("");
                      setSubject2("");
                      setSubject3("");
                      setRefNumber("");
                      setCheckNumber("");
                      setBankAmount(0);
                      setAccountName("");
                      setIsSubject2Disabled(true);
                      setIsSubject3Disabled(true);
                      if (checkStatusValue === "Check") {
                        setAmount(balance_now.toFixed(2).toString());
                      }
                    }}
                    value={checkOrNone}
                    disabled={isPaymentInputDisabled}
                    required
                  >
                    <option value="" disabled>
                      Select Cheque Status
                    </option>
                    <option value="none">Non-Cheque</option>
                    {selectedPayment !== "Cash" && (
                      <option value="Check">Cheque</option>
                    )}
                  </Form.Select>
                </Form.Group>

                {checkOrNone !== "Check" && (
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-bold">
                      Step 1 / Subject <span className="text-danger">*</span>
                      <br />
                      {isVisibleLiabNote && (
                        <span
                          className="fst-italic text-danger"
                          style={{ fontSize: 9.5 }}
                        >
                          (Please be advised that this liability will result in
                          a deduction from the selected account upon collection)
                        </span>
                      )}
                    </Form.Label>
                    <Form.Select
                      onChange={handleSubject1Change}
                      value={subject1}
                      required={checkOrNone !== "Check"}
                      disabled={isPaymentInputDisabled}
                    >
                      <option value="" selected disabled>
                        Select Subject 1
                      </option>
                      <option value="Account-List">Account-List</option>
                      <option value="Asset Account">Asset Account</option>
                      <option value="Liabilities Account">
                        Liabilities Account
                      </option>
                      <option value="Owner's Equity Account">
                        Owner's Equity Account
                      </option>
                    </Form.Select>
                  </Form.Group>
                )}

                {checkOrNone !== "Check" && (
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-bold">
                      Step 2 / Subject <span className="text-danger">*</span>
                    </Form.Label>
                    <Select
                      options={subject2Options}
                      value={subject2}
                      onChange={(selectedOption) =>
                        handleSubject2Change(selectedOption)
                      }
                      placeholder={`Select Subject 2`}
                      styles={selectCustomStyles(subject2, validated)}
                      isDisabled={isSubject2Disabled}
                      required={checkOrNone !== "Check"}
                      isSearchable
                    />
                  </Form.Group>
                )}

                {checkOrNone !== "Check" && (
                  <Form.Group className="mb-3" controlId="accountName">
                    <Form.Label className="fw-bold">
                      Accounts <span className="text-danger">*</span>
                    </Form.Label>
                    <Select
                      options={subject3Options}
                      value={subject3}
                      onChange={handleAccountChange}
                      placeholder={`Select Account name`}
                      styles={selectCustomStyles(subject3, validated)}
                      isDisabled={isSubject3Disabled}
                      required={checkOrNone !== "Check"}
                      isSearchable
                    />
                  </Form.Group>
                )}

                {checkOrNone === "Check" && (
                  <Form.Group className="mb-3" controlId="checkNumber">
                    <Form.Label>Check #</Form.Label>
                    <Form.Control
                      type="text"
                      className="p-2"
                      placeholder="000000-000-0000"
                      value={checkNumber}
                      onChange={(e) => {
                        if (checkProcessDateForPayment()) return;
                        if (checkEditPayment()) return;
                        const value = e.target.value;
                        setCheckNumber(value);
                      }}
                      disabled={isPaymentInputDisabled}
                      required={checkOrNone === "Check"}
                    />
                    <CheckNumberError
                      value={checkNumber}
                      disabled={selectedPayment !== "Bank"}
                      pending={floatPayment
                        .filter((payment) => !payment.isDeleted)
                        .map((payment) => payment.checkNumber)}
                    />
                  </Form.Group>
                )}

                <Form.Group className="mb-3" controlId="date">
                  <Form.Label>
                    Issue Check Date (Maturity Date){" "}
                    <span className="text-danger">*</span>
                  </Form.Label>
                  <CustomDatePicker
                    label={"Issue Check Date"}
                    selected={issueCheckDate ? new Date(issueCheckDate) : ""}
                    handleDateChange={handleIssueCheckDate}
                    CustomInput={CustomInput}
                    isRequired={true}
                    validated={validated}
                    disabled={selectedPayment === "Cash"} // Add this line
                    minDate={
                      processDate
                        ? new Date(new Date(processDate).setHours(0, 0, 0, 0))
                        : undefined
                    }
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="amount">
                  <Form.Label>
                    Amount <span className="text-danger">*</span>
                  </Form.Label>
                  <InputGroup>
                    <InputGroup.Text>
                      {currencySymbol[currencyName] || ""}
                    </InputGroup.Text>
                    <NumberInDecimals
                      className="form-control p-2"
                      required
                      placeholder="0.00"
                      value={amount}
                      decimals={2}
                      onChange={handleAmountValue}
                      disabled={isPaymentInputDisabled}
                    />
                  </InputGroup>
                  {accessType === "Management" && accountName && (
                    <span>
                      Account Balance:{" "}
                      <strong>
                        {bankAmount.toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </strong>
                    </span>
                  )}
                </Form.Group>
                <Button
                  type="submit"
                  variant="primary"
                  className="w-100 p-2"
                  disabled={isPaymentInputDisabled}
                >
                  Add Payment
                </Button>
              </Form>
            </div>
          </Col>
          <Col xs={12} md={8} className="p-2 d-flex flex-column">
            <div className="w-100 border shadow-sm p-2 rounded mb-2">
              <div className="w-100 d-flex flex-column payment-card border-bottom pb-2 mb-3">
                <span className="fw-bold">Payment List</span>
              </div>
              <div className="mt-3">
                <Table bordered hover responsive className="fixed-inputs-table">
                  <thead>
                    <tr>
                      <th className="p-2">Type</th>
                      {/* <th className="p-2">Transaction Number</th> */}
                      <th className="p-2">Account Name</th>
                      <th className="p-2">Amount</th>
                      <th className="p-2">Check Number</th>
                      {/* <th className="p-2">Ref Number</th> */}
                      <th className="p-2">Maturity Date</th>
                      {/* <th className="p-2">Process Date</th> */}
                      {isEditing && <th className="p-2">Actions</th>}
                    </tr>
                  </thead>
                  {floatPayment.some(
                    (data) =>
                      data.status !== "Rejected" && data.isDeleted !== true,
                  ) ? (
                    <tbody>
                      {floatPayment.map(
                        (data, i) =>
                          data.status !== "Rejected" &&
                          data.isDeleted !== true && (
                            <tr key={i}>
                              <td>{data.paymentMethod || "---"}</td>
                              {/* <td>{data.transactionNumber || "---"}</td> */}
                              <td>{data.accountName || "---"}</td>
                              <td>
                                {editableRow === i ? (
                                  <InputGroup>
                                    <InputGroup.Text>
                                      {currencySymbol[currencyName] || ""}
                                    </InputGroup.Text>
                                    <NumberInDecimals
                                      className="form-control"
                                      value={editedData.amount}
                                      decimals={2}
                                      onChange={handleEditAmountValue}
                                      onKeyDown={(e) =>
                                        e.key === "Enter" && handleSaveEdit(i)
                                      }
                                    />
                                  </InputGroup>
                                ) : (
                                  <InputGroup>
                                    <InputGroup.Text>
                                      {currencySymbol[currencyName] || ""}
                                    </InputGroup.Text>
                                    <Form.Control
                                      type="text"
                                      className="pointer-events-none"
                                      value={truncateToTwoDecimals(data.amount)}
                                      readOnly
                                    />
                                  </InputGroup>
                                )}
                              </td>
                              <td>
                                {editableRow === i ? (
                                  <>
                                    <Form.Control
                                      type="text"
                                      value={editedData.checkNumber}
                                      onChange={(e) =>
                                        setEditedData((prev) => ({
                                          ...prev,
                                          checkNumber: e.target.value,
                                        }))
                                      }
                                      onKeyDown={(e) =>
                                        e.key === "Enter" && handleSaveEdit(i)
                                      }
                                      placeholder="---"
                                    />
                                    <CheckNumberError
                                      value={editedData.checkNumber}
                                      ignore={[data.checkNumber]}
                                      pending={floatPayment
                                        .filter(
                                          (payment, j) =>
                                            j !== i && !payment.isDeleted,
                                        )
                                        .map((payment) => payment.checkNumber)}
                                    />
                                  </>
                                ) : (
                                  <Form.Control
                                    type="text"
                                    className="pointer-events-none"
                                    value={data.checkNumber || "---"}
                                    readOnly
                                  />
                                )}
                              </td>
                              {/* <td>
                          {data.refNumber === "" ? "---" : data.refNumber}
                        </td> */}
                              <td>
                                <CustomDatePicker
                                  index={i}
                                  label={"Issued Check Date"}
                                  selected={
                                    editableRow === i
                                      ? editedData.issuedDate
                                        ? new Date(editedData.issuedDate)
                                        : null
                                      : data.issuedDate
                                        ? new Date(data.issuedDate)
                                        : null
                                  }
                                  handleDateChange={(date) =>
                                    handleEditIssuedDate(date, i)
                                  }
                                  CustomInput={CustomInput}
                                  isRequired={true}
                                  validated={validated}
                                  disabled={data.paymentMethod === "Cash"}
                                />
                              </td>
                              {/* <td>
                            <DatePicker
                              selected={
                                data.processDate
                                  ? new Date(data.processDate)
                                  : ""
                              }
                              dateFormat="MMM/dd/yyyy"
                              className="form-control p-2"
                              readOnly
                            />
                          </td> */}
                              {isEditing && (
                                <td className="text-center d-flex">
                                  {editableRow === i ? (
                                    <>
                                      <Button
                                        size="sm"
                                        variant="outline-success"
                                        className="me-1"
                                        onClick={() => handleSaveEdit(i)}
                                        disabled={balance_now < 0}
                                        title="Save Changes"
                                      >
                                        <i className="fa-solid fa-check"></i>
                                      </Button>
                                      <Button
                                        size="sm"
                                        variant="outline-secondary"
                                        onClick={() => setEditableRow(null)}
                                        title="Cancel"
                                      >
                                        <i className="fa-solid fa-xmark"></i>
                                      </Button>
                                    </>
                                  ) : (
                                    <>
                                      <Button
                                        size="sm"
                                        variant="outline-primary"
                                        className="me-1"
                                        onClick={() => handleEditClick(i, data)}
                                        title="Edit Payment"
                                      >
                                        <i className="fa-solid fa-edit"></i>
                                      </Button>
                                      <Button
                                        size="sm"
                                        variant="outline-danger"
                                        onClick={() =>
                                          handleDeletePayment(i, data)
                                        }
                                        title="Delete Payment"
                                      >
                                        <i className="fa-solid fa-trash"></i>
                                      </Button>
                                    </>
                                  )}
                                </td>
                              )}
                            </tr>
                          ),
                      )}
                    </tbody>
                  ) : (
                    <caption className="text-center mt-3">
                      There are no records to display
                    </caption>
                  )}
                </Table>
              </div>
            </div>
            <div className="w-100 border shadow-sm p-2 rounded">
              <div className="w-100 d-flex flex-column payment-card border-bottom pb-2 mb-3">
                <span className="fw-bold">Balance Details</span>
              </div>
              <Row className="row">
                {/* Left Side: Order List Summary */}
                <Col xs={12} lg={5} className="mb-4 mb-lg-0">
                  <div className="w-100 d-flex flex-row justify-content-between p-2">
                    <span>Gross Amount :</span>
                    <span className="text-secondary">
                      {`${currencySymbol[currencyName] || ""} ${truncateToTwoDecimals(totalAmountSum)}`}
                    </span>
                  </div>
                  <div className="w-100 d-flex flex-row justify-content-between p-2">
                    <span>Overall Discount :</span>
                    <span
                      className={`${
                        overAllDiscount.convertedAmount > 0
                          ? "text-danger"
                          : overAllDiscount.convertedAmount < 0
                            ? "text-success"
                            : "text-secondary"
                      }`}
                    >
                      {`${currencySymbol[currencyName] || ""} ${truncateToTwoDecimals(
                        Math.abs(overAllDiscount.convertedAmount),
                      )}`}
                    </span>
                  </div>

                  <div className="w-100 d-flex flex-row justify-content-between p-3 mt-3 total-amount-container align-items-center rounded">
                    <span className="text-white">Receivable Balance</span>
                    <span className="text-white text-underline">
                      {`${currencySymbol[currencyName]} ${truncateToTwoDecimals(balance_now)}`}
                    </span>
                  </div>
                  <div className="w-100 d-flex flex-row justify-content-between p-3 mt-3 total-amount-container align-items-center rounded">
                    <span className="text-white">Advance Payment</span>
                    <span className="text-white text-underline">
                      {`${currencySymbol[currencyName] || ""} ${truncateToTwoDecimals(advance_payment)}`}
                    </span>
                  </div>
                </Col>

                {/* Spacer block (hidden on mobile, visible on large screens) */}
                <Col lg={2} className="d-none d-lg-block"></Col>

                <Col xs={12} lg={5}>
                  <div className="w-100 d-flex flex-row justify-content-between p-2">
                    <span>Cash</span>
                    <span className="text-secondary">
                      {truncateToTwoDecimals(totalCashPaid)}
                    </span>
                  </div>
                  <div className="w-100 d-flex flex-row justify-content-between p-2">
                    <span>Bank</span>
                    <span className="text-secondary">
                      {truncateToTwoDecimals(totalBankPaid)}
                    </span>
                  </div>
                  <div className="w-100 d-flex flex-row justify-content-between p-2">
                    <span>Check</span>
                    <span className="text-secondary">
                      {truncateToTwoDecimals(totalCheckPaid)}
                    </span>
                  </div>
                  {/* <div className="w-100 d-flex flex-row justify-content-between p-2">
                    <span>Online</span>
                    <span className="text-secondary">
                      {truncateToTwoDecimals(totalOnlinePaid)}
                    </span>
                  </div> */}
                  <div className="w-100 d-flex flex-row justify-content-between p-3 mt-3 total-amount-container align-items-center rounded">
                    <span className="text-white">Total Payment</span>
                    <span className="text-white text-underline">
                      {`${currencySymbol[currencyName]} ${truncateToTwoDecimals(totalPayment)}`}
                    </span>
                  </div>
                </Col>
              </Row>
            </div>
            <Row className="mt-4">
              <Col sm></Col>
              <Col sm></Col>
              <Col sm>
                <Row>
                  {balance_now < 0 && (
                    <span className="fs-6 text-danger mb-2">
                      Balance cannot be less than zero
                    </span>
                  )}
                  <Col sm className="d-flex flex-row mb-2 w-100">
                    <div className="w-100 me-3">
                      {!isEditing && status === "For Approval" && (
                        <Button
                          variant="outline-primary"
                          className="w-100 px-4"
                          type="button"
                          onClick={(e) => {
                            e.preventDefault();
                            setIsEditing(true);
                            setEdit(true);
                          }}
                        >
                          Edit
                        </Button>
                      )}
                    </div>
                    {authrztn.includes("LocalCollections-Approve") &&
                    status === "For Approval" &&
                    !isEditing ? (
                      <>
                        <Button
                          variant="outline-danger"
                          className="w-100 me-3"
                          type="button"
                          onClick={(e) =>
                            handleApproveRejectLocalCollection(e, "reject")
                          }
                          disabled={isCutoffPosted || !isCutoffExists}
                        >
                          Reject
                        </Button>
                        <Button
                          variant="outline-success"
                          className="w-100"
                          type="button"
                          onClick={(e) =>
                            handleApproveRejectLocalCollection(e, "approve")
                          }
                          disabled={
                            isCutoffPosted || !isCutoffExists || balance_now < 0
                          }
                        >
                          Approve
                        </Button>
                      </>
                    ) : (
                      <>
                        {authrztn.includes("LocalCollections-Edit") &&
                          status === "For Approval" && (
                            <>
                              {isEditing && (
                                <>
                                  <Col className="align-items-end mb-2 w-100">
                                    <div className="d-flex flex-row">
                                      <Button
                                        variant="secondary"
                                        className="w-100 me-3"
                                        type="button"
                                        onClick={handleCancelEdit}
                                        // onClick={() => {
                                        //   swal({
                                        //     icon: "warning",
                                        //     title: "Are you sure?",
                                        //     text: "Your changes will not be saved",
                                        //     buttons: ["Cancel", "OK"],
                                        //     dangerMode: true,
                                        //   }).then((confirmed) => {
                                        //     if (confirmed) {
                                        //       const payload = JSON.stringify({
                                        //         id,
                                        //         idToAdd: transactionToGetBack,
                                        //       });
                                        //       const blob = new Blob([payload], {
                                        //         type: "application/json",
                                        //       });

                                        //       navigator.sendBeacon(
                                        //         `${BASE_URL}/bulkcollection/getBackOrderListTransaction`,
                                        //         blob,
                                        //       );

                                        //       setIsEditing(false);
                                        //       setTransactionToGetBack([]);
                                        //       setIdToAdd([]);
                                        //       setId(null);
                                        //       setEdit(false);
                                        //       setSelectedRow([]);
                                        //       setSelectedRowTransactions([]);
                                        //       window.onbeforeunload = null;
                                        //     }
                                        //     return;
                                        //   });
                                        // }}
                                      >
                                        Cancel
                                      </Button>
                                      <Button
                                        variant="primary"
                                        className="w-100"
                                        type="button"
                                        onClick={handleUpdateLocalCollection}
                                        disabled={balance_now < 0}
                                      >
                                        Update
                                      </Button>
                                    </div>
                                  </Col>
                                </>
                              )}
                            </>
                          )}
                      </>
                    )}
                  </Col>

                  {(authrztn.includes("LocalCollections-Edit") ||
                    authrztn.includes("LocalCollections-Approve")) &&
                    isCutoffPosted &&
                    status !== "Claimed" && (
                      <div>
                        <p className="text-danger">
                          Action is prohibited as the transaction date has
                          already been posted.
                        </p>
                      </div>
                    )}

                  {(authrztn.includes("LocalCollections-Edit") ||
                    authrztn.includes("LocalCollections-Approve")) &&
                    !isCutoffExists &&
                    status !== "Claimed" && (
                      <div>
                        <p className="text-danger">
                          Action is prohibited as the transaction date has not
                          been created.
                        </p>
                      </div>
                    )}
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default NewViewBulkCollection;
